var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26557",
    "data-name": "Group 26557",
    transform: "translate(-21.5 -190)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7562",
    "data-name": "Rectangle 7562",
    width: 26,
    height: 24,
    rx: 6,
    transform: "translate(21.5 190)",
    fill: "#ff8900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(27 195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7560",
    "data-name": "Rectangle 7560",
    width: 14,
    height: 14,
    transform: "translate(0.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(2.042 0.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142422",
    "data-name": "Path 142422",
    d: "M19.042,11.167a.875.875,0,1,1-.875.875.846.846,0,0,1,.875-.875m0-1.167a2.042,2.042,0,1,0,2.042,2.042A2.042,2.042,0,0,0,19.042,10Z",
    transform: "translate(-14.083 -7.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142423",
    "data-name": "Path 142423",
    d: "M11.958,3.167A3.858,3.858,0,0,1,15.75,7.25c0,2.333-2.508,4.871-3.792,6.183-1.283-1.312-3.792-4-3.792-6.183a3.946,3.946,0,0,1,3.792-4.083m0-1.167A5.023,5.023,0,0,0,7,7.25c0,2.887,3.354,6.212,4.55,7.408a.554.554,0,0,0,.817,0c1.2-1.2,4.55-4.463,4.55-7.408A4.989,4.989,0,0,0,11.958,2Z",
    transform: "translate(-7 -2)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c1999ef3012cde2a4446385eabac955d.svg";
export { ForwardRef as ReactComponent };